import Intercom from '@intercom/messenger-js-sdk';

export const initIntercom = (appId, email, name, options = {}) => {
  Intercom({
    app_id: appId,
    email: email,
    name: name,
    ...options,
    api_base: 'https://intercom.io'
  });
};